"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _shortid = _interopRequireDefault(require("shortid"));

var _togaLabel = _interopRequireDefault(require("@thinkific/toga-label"));

var _Textarea = _interopRequireDefault(require("./Textarea.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_Textarea["default"]);

var Textarea = function Textarea(_ref) {
  var className = _ref.className,
      id = _ref.id,
      label = _ref.label,
      formText = _ref.formText,
      hasError = _ref.hasError,
      props = _objectWithoutProperties(_ref, ["className", "id", "label", "formText", "hasError"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('form-group', 'textarea__box')
  }, label && /*#__PURE__*/_react["default"].createElement(_togaLabel["default"], {
    className: cx('label', 'textarea__label'),
    htmlFor: id
  }, label), /*#__PURE__*/_react["default"].createElement("textarea", _extends({
    className: cx('form-control', 'textarea__textarea', className, {
      'has-error': hasError
    }),
    id: id
  }, props)), formText && /*#__PURE__*/_react["default"].createElement("span", {
    className: cx('form-text', {
      'has-error': hasError
    })
  }, formText));
};

Textarea.propTypes = {
  /** CSS classes applied to textarea */
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object, _propTypes["default"].arrayOf(_propTypes["default"].string)]),

  /** Optional form text */
  formText: _propTypes["default"].string,

  /** Optional bool to set error style */
  hasError: _propTypes["default"].bool,

  /** Optional textarea ID */
  id: _propTypes["default"].string,

  /** Optional label */
  label: _propTypes["default"].string
};
Textarea.defaultProps = {
  className: null,
  formText: null,
  hasError: false,
  id: _shortid["default"].generate(),
  label: null
}; // force bump 2

var _default = Textarea;
exports["default"] = _default;